module.exports = __webpack_public_path__ + "img/01-T.52a84716.png";